module.exports = __webpack_public_path__ + "static/img/shouye2.0eb3543.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouye/shouye2.png
// module id = NFYx
// module chunks = 17